import { r as registerInstance, c as createEvent, h, g as getElement } from './index-d4808923.js';
import { b as bem } from './index.esm-7182addc.js';
import { a as attachObserverToInput } from './inputObserver-6de9a524.js';

const gravityTagInputCss = ".gravity-tag-input{display:flex;flex-direction:column}.gravity-tag-input__input-block{align-items:center;background-color:#FFFFFF;border-bottom:var(--gravity-tag-input-border-bottom, 1px solid rgba(0, 15, 30, 0.2));border-left:var(--gravity-tag-input-border-left, 1px solid rgba(0, 15, 30, 0.2));border-radius:var(--gravity-tag-input-border-radius, 6px);border-right:var(--gravity-tag-input-border-right, 1px solid rgba(0, 15, 30, 0.2));border-top:var(--gravity-tag-input-border-top, 1px solid rgba(0, 15, 30, 0.2));box-sizing:border-box;cursor:text;display:flex;flex-direction:row;min-height:40px;padding:5px 12px}.gravity-tag-input__input-block:hover{border-color:rgba(0, 15, 30, 0.45)}.gravity-tag-input__input-block:focus-within{outline:#1B6AEE solid 2px;outline-offset:2px}.gravity-tag-input__input-block .input{background-color:transparent;border:0;color:#000F1E;flex:1;font-family:\"Bull\", Helvetica, sans-serif;font-size:16px;font-weight:normal;line-height:1.5;padding:0;width:100%}.gravity-tag-input__input-block .input:invalid{box-shadow:none}.gravity-tag-input__input-block .input:focus{outline:none}.gravity-tag-input__input-block .input::placeholder{color:rgba(0, 15, 30, 0.4);font-weight:normal}.gravity-tag-input__input-block__tags{align-items:center;display:flex;flex:1;flex-flow:wrap;gap:4px}.gravity-tag-input--size-small .gravity-tag-input__input-block{border-radius:var(--gravity-tag-input-border-radius, 4px);min-height:32px;padding:5px 8px}.gravity-tag-input--size-small .gravity-tag-input__input-block .input{font-size:14px;line-height:1.428571}.gravity-tag-input--size-small .gravity-tag-input__input-block__tags{gap:4px}.gravity-tag-input--invalid .gravity-tag-input__input-block{border-color:#DB0A40}.gravity-tag-input--required .gravity-tag-input__input-block{border-color:#DB0A40}.gravity-tag-input--disabled .gravity-tag-input__input-block,.gravity-tag-input--disabled .gravity-tag-input__input-block:hover,.gravity-tag-input--disabled .gravity-tag-input__input-block:focus-within{background-color:rgba(0, 15, 30, 0.05);border-color:transparent}.gravity-tag-input--highlighted .gravity-tag-input__input-block{background-color:#F4F8FE}.gravity-tag-input--highlighted .gravity-tag-input__input-block,.gravity-tag-input--highlighted .gravity-tag-input__input-block:hover,.gravity-tag-input--highlighted .gravity-tag-input__input-block:focus-within{background-color:#F4F8FE}";
const GravityTagInputStyle0 = gravityTagInputCss;

const generateClassNames = bem('gravity-tag-input');
const GravityTagInput = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.inputChanged = createEvent(this, "inputChanged", 5);
        this.disabled = false;
        this.ellipsis = true;
        this.highlighted = false;
        this.infoBottom = false;
        this.infoPosition = 'top';
        this.infoText = '';
        this.infoWidth = undefined;
        this.inline = false;
        this.inlineLabelWidth = '33%';
        this.invalid = false;
        this.label = '';
        this.placeholder = 'Add a tag';
        this.required = false;
        this.size = 'medium';
        this.tags = [];
        this.validationMessage = '';
        this.valueMissing = false;
    }
    requiredChangeHandler() {
        if (!this.required && this.valueMissing) {
            this.valueMissing = false;
        }
    }
    removeTag(index) {
        this.tags = [...this.tags.slice(0, index), ...this.tags.slice(index + 1)];
        this.inputChanged.emit(this.tags);
        this.validate();
    }
    addTag() {
        const inputValue = this.input.value.trim();
        if (!inputValue) {
            return;
        }
        this.input.value = '';
        this.tags = [...this.tags, inputValue];
        this.inputChanged.emit(this.tags);
        this.validate();
    }
    removeLastTag() {
        if (this.tags.length) {
            this.tags = this.tags.splice(0, this.tags.length - 1);
        }
        this.inputChanged.emit(this.tags);
        this.validate();
    }
    validate() {
        this.valueMissing = this.required && this.tags.length == 0;
    }
    setListeners() {
        this.input.onkeydown = ($event) => {
            if ($event.key == 'Enter') {
                this.addTag();
            }
            if ($event.key == 'Backspace' && this.input.value.length === 0) {
                this.removeLastTag();
            }
        };
        this.element.onclick = () => {
            if (this.disabled) {
                return;
            }
            this.input.focus();
        };
        this.element.onblur = () => {
            if (this.disabled) {
                return;
            }
            this.addTag();
            this.validate();
        };
    }
    componentDidLoad() {
        this.setListeners();
        /**
         * This is a temp fix for Last Pass issue of truthy attributes in input fields
         * for example: readonly="false" resolves to readonly
         * TODO: Remove this when Last Pass issue is fixed: https://github.com/redbullmediahouse/rbds-cosmos/issues/2951
         */
        attachObserverToInput(this.input, this.inputObserver);
    }
    render() {
        return (h("gravity-form-field", { key: '8640c2f1f3f892c7b28164745d9fadb1138bbd47', label: this.label, required: this.required, disabled: this.disabled, highlighted: this.highlighted, infoBottom: this.infoBottom, infoText: this.infoText, infoPosition: this.infoPosition, infoWidth: this.infoWidth, inline: this.inline, inlineLabelWidth: this.inlineLabelWidth, size: this.size, invalid: !!this.validationMessage || this.valueMissing, validationMessage: this.valueMissing ? 'This field is required' : this.validationMessage }, h("div", { key: '7a6c756ecd8d7369ce58271fa9ac9583f307adb3', class: generateClassNames({
                inline: this.inline,
                disabled: this.disabled,
                highlighted: this.highlighted,
                required: this.valueMissing,
                invalid: this.invalid || !!this.validationMessage,
                size: this.size,
            }) }, h("div", { key: '444c99706c95854feaabe2c8e19aef1c52765e29', class: generateClassNames('input-block') }, h("div", { key: '0c3738f94d46a82ef40371ed828e434d079f1a11', class: generateClassNames('input-block__tags') }, this.tags.map((label, index) => (h("gravity-tag", { class: "tag", color: "dark", ellipsis: this.ellipsis, removable: !this.disabled, onTagRemoved: () => this.removeTag(index), onClick: (event) => event.stopPropagation(), size: this.size === 'small' ? 'small' : 'large' }, label))), h("input", { key: '99afb5f8346005ae16935ef8c167871274fbbb53', class: "input", type: "text", placeholder: this.tags.length ? '' : this.placeholder, required: this.required, disabled: this.disabled, ref: (el) => (this.input = el), value: "" }))))));
    }
    get element() { return getElement(this); }
    static get watchers() { return {
        "required": ["requiredChangeHandler"]
    }; }
};
GravityTagInput.style = GravityTagInputStyle0;

export { GravityTagInput as gravity_tag_input };

//# sourceMappingURL=gravity-tag-input.entry.js.map